// extracted by mini-css-extract-plugin
export default {"container":"TeamAssignment_container__TwcRd"};